import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { Promise } from "rsvp"

export default class LessonRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return new Promise((resolve, reject) => {
      get(this, "store")
        .find("card-stack", params.lesson_id)
        .then((cardStack) => {
          return get(this, "store")
            .find("course", cardStack.relationships.course.data.id)
            .then((course) => {
              resolve({ cardStack, course })
            })
        })
    })
  }
}
